import React from "react";

/**
 * PV monogram logo — minimal editorial mark.
 */
export default function Monogram({ size = 36, withWord = false }) {
  return (
    <a href="/" data-cursor="HOME" data-testid="logo-home" className="inline-flex items-center gap-3 group">
      <svg width={size} height={size} viewBox="0 0 48 48" className="shrink-0">
        <rect x="0.5" y="0.5" width="47" height="47" fill="none" stroke="currentColor" strokeOpacity="0.35" />
        {/* P */}
        <path
          d="M11 36 V12 H21 a6 6 0 0 1 0 12 H14"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
        />
        {/* V */}
        <path
          d="M25 12 L33 36 L41 12"
          fill="none"
          stroke="#b21e29"
          strokeWidth="2"
          strokeLinecap="square"
        />
      </svg>
      {withWord && (
        <span className="font-serif-editorial text-xl tracking-tight">Phaneroo Prod</span>
      )}
    </a>
  );
}
